import map from 'lodash/map';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Flex, Input, Select } from 'roo-ui/components';
import { EMAIL_ENQUIRY_TYPES } from 'lib/enums/contactUs';
import AirbnbDetails from './AirbnbDetails';
import { FieldError, FieldLabel } from 'components/Form';
import { useDataLayer } from 'hooks/useDataLayer';

const bookingEnquiryTypes = ['amendment', 'cancellation', 'existingReservation'];
const fieldConfig = {
  bookingReference: {
    required: 'Please enter your booking reference',
    maxLength: {
      message: 'Booking reference should be a maximum of 10 characters',
      value: 10,
    },
  },
  enquiryType: {
    required: 'Please select an enquiry type',
  },
};

const EnquiryDetails = ({ errors, register, setValue, unregister, watch }) => {
  const { emitInteractionEvent } = useDataLayer();
  const enquiryType = watch('enquiryType');

  const isAirbnbEnquiry = enquiryType === 'airbnb';
  const isBookingEnquiry = bookingEnquiryTypes.includes(enquiryType);

  useEffect(() => {
    if (!enquiryType) return;

    const capitalizedEnquiryType = enquiryType.replace(/^./, (str) => str.toUpperCase());
    emitInteractionEvent({ type: 'Help Topic Dropdown', value: `${capitalizedEnquiryType} Enquiry Selected` });
  }, [emitInteractionEvent, enquiryType]);

  return (
    <Flex flexDirection="column" mb={4} width={[1, 2 / 3]}>
      <FieldLabel htmlFor="enquiryType" mb={2}>
        Enquiry Type
        <Select id="enquiryType" name="enquiryType" defaultValue="" ref={register(fieldConfig.enquiryType)} error={!!errors.enquiryType}>
          <option disabled value="">
            Please select an enquiry type
          </option>
          {map(EMAIL_ENQUIRY_TYPES, (type, key) => (
            <option key={key} value={key}>
              {type.label}
            </option>
          ))}
        </Select>
        <FieldError error={errors.enquiryType} data-testid="enquiry-type-error" />
      </FieldLabel>

      {isAirbnbEnquiry && <AirbnbDetails errors={errors} register={register} setValue={setValue} unregister={unregister} />}

      {isBookingEnquiry && (
        <FieldLabel htmlFor="bookingReference" flex="1 1 auto">
          Booking reference
          <Input
            id="bookingReference"
            name="bookingReference"
            ref={register(fieldConfig.bookingReference)}
            error={!!errors.bookingReference}
          />
          <FieldError error={errors.bookingReference} data-testid="booking-reference-error" />
        </FieldLabel>
      )}
    </Flex>
  );
};

EnquiryDetails.propTypes = {
  errors: PropTypes.object,
  register: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  unregister: PropTypes.func.isRequired,
};

EnquiryDetails.defaultProps = {
  errors: {},
};

export default EnquiryDetails;
